import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { getContadoresTareasProyectos, getProyecto, verificarToken } from '../../services/apis';

import CircularProgress from '@mui/material/CircularProgress';
import { Grid, Typography } from '@mui/material';

import { ErrorYRedireccionar } from '../../utils/componentes-utiles/ErrorYRedireccionar';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader';
import { OpcionesMenuUrlId } from '../../utils/componentes-utiles/OpcionesMenuUrlId';
import { ArchivosProyecto } from './ArchivosProyecto';


export const Proyecto = () => {
    // Global

    // Estados auxiliares
    const [loaded, setLoaded] = useState(false);

    // Estados útiles
    const [opciones, setOpciones] = useState([]);
    const [infoProyecto, setInfoProyecto] = useState({})
    const [resumenProyecto, setResumenProyecto] = useState(null);
    const [rolUsuario, setRolUsuario] = useState(null);
    const param = useParams();

    const colorEstado = (color) => {
        if (!color) return '#ffffff';
        return color.startsWith('#') ? color : `#${color}`;
    };

    const nombreEstadoResumen = (nombre) => {
        if (!nombre) return '';
        return nombre.toLowerCase() === 'en espera' ? 'Sin iniciar' : nombre;
    };

    const estadosConSinAsignar = (resumen) => {
        const estados = Array.isArray(resumen?.estados) ? [...resumen.estados] : [];
        const sinAsignar = {
            id_estado: 'sin_asignar',
            nombre: 'Sin asignar',
            color: 'f44336',
            total: Number(resumen?.sin_asignar ?? 0),
        };
        const descartadas = {
            id_estado: 'descartadas',
            nombre: 'Descartadas',
            color: '9e9e9e',
            total: Number(resumen?.descartadas ?? 0),
        };
        const indiceValidado = estados.findIndex((estado) => estado.nombre?.toLowerCase() === 'validado');

        if (indiceValidado >= 0) {
            estados.splice(indiceValidado + 1, 0, sinAsignar);
        } else {
            estados.push(sinAsignar);
        }

        estados.push(descartadas);
        return estados;
    };

    // Cargar opciones menú principal y la informacion
    const cargarProyecto = async () => {
        try {
            const token = await verificarToken();
            const rol = token?.rol ?? token?.usuario?.id_rol ?? token?.data?.usuario?.id_rol;
            setRolUsuario(rol);

            const response = await getProyecto(param.id);
            setOpciones(response.data.opciones);
            setInfoProyecto(response.data.info[0]);

            if (String(rol) === '986') {
                const responseContadores = await getContadoresTareasProyectos(1);
                setResumenProyecto(responseContadores.data?.[String(param.id)] ?? null);
            }

            setLoaded(true);
        } catch (error) {
            console.error("Error al añadir el cliente:", error);

        }
    };

    useEffect(() => {
        cargarProyecto();
    }, []);
    return (
        <div className='menu-back fade-in-2'>
            {!loaded && (
                <CircularProgress />
            )}
            {loaded && (
                <>
                    <SubHeader />
                    <h1> {infoProyecto ? infoProyecto.nombre ? infoProyecto.nombre.toUpperCase() : '' : <ErrorYRedireccionar mensaje={'No tienes acceso a este Proyecto'} />}</h1>
                    {infoProyecto?.id || infoProyecto?.id === 0 && (
                        <ArchivosProyecto idProyecto={infoProyecto.id} />
                    )}
                    {String(rolUsuario) === '986' && resumenProyecto && (
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            gap={1}
                            sx={{ mt: 2, mx: 'auto', p: 1.5, border: '1px solid #e0e0e0', borderRadius: 2, maxWidth: 1280 }}
                        >
                            <Grid
                                item
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #d0d0d0',
                                    borderRadius: 1,
                                    px: 1.5,
                                    py: 0.75,
                                    backgroundColor: '#fff',
                                    minWidth: 145,
                                }}
                            >
                                <Typography variant="caption" sx={{ fontWeight: 800 }}>
                                    Tareas totales: {resumenProyecto.total ?? 0}
                                </Typography>
                            </Grid>
                            {estadosConSinAsignar(resumenProyecto).map((estado) => (
                                <Grid
                                    item
                                    key={estado.id_estado}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        border: '1px solid #d0d0d0',
                                        borderRadius: 1,
                                        px: 1.5,
                                        py: 0.75,
                                        backgroundColor: '#fff',
                                        minWidth: 130,
                                    }}
                                >
                                    <Grid item sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                        <span
                                            style={{
                                                width: 8,
                                                height: 8,
                                                borderRadius: '50%',
                                                backgroundColor: colorEstado(estado.color),
                                                display: 'inline-block',
                                                flexShrink: 0,
                                                marginRight: 6,
                                                border: estado.color === 'ffffff' ? '1px solid #bdbdbd' : 'none',
                                            }}
                                        />
                                        <Typography variant="caption" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {nombreEstadoResumen(estado.nombre)}
                                        </Typography>
                                    </Grid>
                                    <Typography variant="caption" sx={{ fontWeight: 800, ml: 1 }}>
                                        {estado.total}
                                    </Typography>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                    <OpcionesMenuUrlId opciones={opciones} proyecto={infoProyecto}></OpcionesMenuUrlId>
                </>
            )}
        </div>
    )
}
